import EqualizerIcon from '@material-ui/icons/Equalizer';
import StatSection from './StatSection';
import BarList from './BarList';

// The ratings of the tasks the contestant solved. A board of a [l, r] tournament
// only ever carries tasks rated l, l + 100 and r, so those are the only bars.
function DifficultyCard(props) {
    const difficulty = props.difficulty ?? [];
    const solves = difficulty.reduce((sum, rating) => sum + rating.count, 0);
    return (
        <StatSection
            icon={<EqualizerIcon />}
            title='Difficulty'
        >
            <BarList
                emptyMessage='No task solved yet'
                items={difficulty.map(rating => ({
                    key: rating.rating,
                    label: `${rating.rating}`,
                    value: rating.count,
                    valueLabel: solves === 0 ? `${rating.count}` : `${rating.count} · ${(rating.count * 100 / solves).toFixed(1)}%`,
                    note: rating.attempts == null ? null : `${rating.attempts.toFixed(1)} att/solve`,
                    tooltip: `${rating.count} task${rating.count === 1 ? '' : 's'} rated ${rating.rating}`
                        + (rating.attempts == null ? '' : `, ${rating.attempts.toFixed(2)} submissions per solve`)
                }))}
            />
        </StatSection>
    );
}

export default DifficultyCard;
